import {
	AddressSearchService,
	IAddressSearchResource,
	IAddressSearchResourceClass,
	IPlaceNameSearchResource,
	IPlaceNameSearchResourceClass,
	PlaceNameSearchService,
	SearchService
} from '../services/search';
import {LTServices} from '../lt-ng/lt-services';
import {L} from '../lt-ng/landcare-toolkit';
import {IToastService} from "../services/ToastService";
import {IUsageLoggingService} from "../services/IUsageLoggingService";
import {debounce} from "../utility/debounce";
import {Coordinate} from "ol/coordinate";
import {ICoordinateAdjustmentService} from "../services/coordinate-adjustment";
import FitError = L.map.FitError;
import fitCoordinates = L.map.fitCoordinates;

export interface SearchItem {
	pxid?: string;
	value?: string;
	name?: string;
	x?: number;
	y?: number;
}


interface IResourceAddressFinder<T> {
	completions: ng.resource.IResourceArray<T>;
}

interface SearchCtrlScope extends ng.IScope {
	search: {term: string};
	searchLoading: boolean;
	place: {name: string};
	places: string[];
	clearSearch: () => void;
	clearSearchAndCloseSearch: () => void;
	open(): void;
	selectPlace(name: string): void;
	updatePlaces(typed: string): void;
	closeSearch(): void;
	mobileSearchKeyup(ev : any);
	clickItem(value: any);
	trustAsHtml(value: any): any;
}

export class SearchCtrl {
	public static $inject = ['$scope', 'searchService', 'landcareMapService', '$http',
							'$resource', '$sce', '$timeout', 'toastService', 'usageLoggingService',
							'coordinateAdjustmentService', 'placeNameSearchService'];
	private static MORE_RESULTS = `Open more results...`;
	private placeNameRequest: any;
	constructor(private $scope: SearchCtrlScope,
				searchService: SearchService,
				mapService: LTServices.IMapService,
				protected $http: ng.IHttpService,
				$resource: ng.resource.IResourceService,
				$sce: ng.ISCEService,
				$timeout: ng.ITimeoutService,
				toastService : IToastService,
				usageLoggingService : IUsageLoggingService,
				coordinateAdjustmentService: ICoordinateAdjustmentService,
                placeSearchService: PlaceNameSearchService) {
		$scope.search = {
			term: ''
		};
		$scope.place = {
			name: null
		};
		$scope.$watch('search.term', (value: string) => {
			$scope.updatePlaces(value);
		});

		let places = [];

		let addresses = [];

		const publishDescriptor: ng.resource.IActionDescriptor = {
			method: 'GET',
			isArray: false,
			cancellable: true,
			interceptor: {
				response(response: any): any {
					console.log(response);
					if (Array.isArray(response.data.response)) {
						response.data.response.forEach(r => {
							if ('x' in r && 'y' in r) {
								const a = r.x;
								// noinspection JSSuspiciousNameCombination
								r.x = r.y;
								r.y = a;
							}
						})
					}
					return response.resource;
				}
			},
		};

		$scope.places = [];

		let unpublishDescriptor = {
			method: 'POST'
		};
		let placeNameSearchResource = $resource<IPlaceNameSearchResource, IPlaceNameSearchResourceClass>(placeSearchService.url, null,{
			query: publishDescriptor
		}, {
		});

		function resetPlaceName() {
			$scope.place.name = null;
		}

		function zoomTo(item: IPlaceNameSearchResource | SearchItem) {
			console.log('zoomTo in geoapp.ts');
			if (item.pxid) {
				searchService.addressGoTo(item.pxid);
			} else {
				$timeout(() => {
					let coordinate : Coordinate|FitError = fitCoordinates(
                        mapService.map.getView().getProjection(),
                        item.x, item.y
                    );

                    if (!(coordinate instanceof FitError)) {
                        searchService.animateZoomTo(coordinate, 'zoomLevel' in item ? item.zoomLevel : 5);
                        searchService.highlightLocation(coordinate);
                        resetPlaceName();
                    } else {
                        console.log(coordinate);
                    }
				}, 0);
			}
		}

		$scope.$on('searchModal', (evt, item) => zoomTo(item)); // need for more results template: ../partials/modalSearchResults.html

		$scope.mobileSearchKeyup = (ev : any) => {
			if(ev.keyCode == 13 && $scope.places && $scope.places.length) {
				// the enter key has been pressed
				// go to the first place in the auto-complete results.
				$scope['clickItem']($scope.places[0]);
			}
		};

		let searchType: L.SearchType = L.SearchType.PLACE;
		let myTyped = '';
		$scope.selectPlace = function(name: string) {
			console.log('selected place', name);
			let max: number;
			let view = mapService.view;
			const tagRegex = /<[^>]*>/g;
			switch (searchType) {
				case L.SearchType.ADDRESS:
				case L.SearchType.PLACE:
					let replacedName = name.replace(tagRegex, '');
					let index = replacedName.indexOf(SearchCtrl.MORE_RESULTS.replace(tagRegex, ''));
					switch (searchType) {
						case L.SearchType.ADDRESS:
							usageLoggingService.logWithAnalytics("ADDRESS_SUCCESS", '', name)
							break;
						case L.SearchType.PLACE:
							usageLoggingService.logWithAnalytics("PLACE_SUCCESS", '', name)
							break;
					}
					$scope.search.term = '';
					if (index !== -1) {
						// let search = name.substring(0, index);
						let myType = searchType === L.SearchType.ADDRESS ? 'Address' : 'Place';
						$scope.$root.$broadcast('search' + myType, myTyped);
						resetPlaceName();
						return;
					}
					resetPlaceName();
			}
			switch (searchType) {
				case L.SearchType.COORDINATE:
					if ($scope.place) $scope.place.name = '';
					let parts = name.split(/(,|\s)\s*/);
					let x = Number(parts[0]);
					let y = Number(parts[2]);
					// because of potential truncation error add/subtract 0.000001
					let coord = L.map.fitCoordinates(view.getProjection(), x, y);

					if (coord instanceof L.map.FitError) {
						toastService.showToast('Coordinate outside of New Zealand');
						return;
					}

					const zoom = 8;
					searchService.animateZoomTo(coord, zoom, function() {
						searchService.highlightLocation(<[number,number]> coord);
					});
					break;
					case L.SearchType.ADDRESS:
						max = addresses.length;
					for (let i = 0; i < max; i++) {
						let it = addresses[i];
						if (it.a === name) {
							searchService.addressGoTo(it.pxid);
							return;
						}
					}
					break;
				case L.SearchType.PLACE:
				default:
					max = places.length;
					let match = places.filter(p => p && p.result)
						.filter(p => PlaceNameSearchService.getLongName(p)
						.replace(tagRegex, '') === name.replace(tagRegex, ''))[0];
					if (match) {
						zoomTo(match);
						return;
					}
					break;
			}
		};
		let addressSearchResource = $resource<IAddressSearchResource, IAddressSearchResourceClass>(AddressSearchService.url, null, {
			publish: publishDescriptor,
			unpublish: unpublishDescriptor,
			query: { method: 'GET', isArray: false }
		}, {});
		let placeRegex: RegExp = /^[a-zA-Z]+.*$/g;
		let coordinateRegex: RegExp = /^-?\d+([.]\d+)?(,\s*|\s+)-?\d+([.]\d+)?$/g;
		let addressRegex: RegExp = /^\d+.*$/g;

		$scope.trustAsHtml = $sce.trustAsHtml;

		$scope.clickItem = (value) => {
			console.log('clicked item', value, mapService);
			$scope.closeSearch();
			$scope.selectPlace(value);
			usageLoggingService.logWithAnalytics("ADDRESS_SUCCESS", '', value.toLocaleString())
		};

		let logCategory = "", logSearchTerm = "";

		let _doLogSearch = debounce(() => {
			usageLoggingService.logWithAnalytics(logCategory, "search", logSearchTerm);
		}, 1000);

		let logSearch =  (category : string, searchTerm : string) => {
			logCategory = category;
			logSearchTerm = searchTerm;
			_doLogSearch(); // Don't want to hammer the logging service with every keystroke, so we go through
			// this debounced function
		};

		$scope.updatePlaces = (typed: string) => {
			if (typed == null || typed.length < 1) {
				$scope.places = [];
				return;
			}

			if (typed.indexOf(SearchCtrl.MORE_RESULTS) !== -1) {
				return;
			}
			myTyped = typed;
			// Loading...
			//$scope.places = [$sce.trustAsHtml('<span class="icon icon-spinner spinning"></span>')];
			$scope.searchLoading = true;
			//if (1==1) return;

			let checkForNoResults = () => {
				if (typed.length > 0 && $scope.places.length == 0) {
					toastService.showToast('No results found');
				}
			};
			if (typed.match(coordinateRegex) !== null) {
				searchType = L.SearchType.COORDINATE;
				$scope.places = [
					typed + ' Coordinate'
				];
				logSearch("COORDINATE_SEARCH", typed);
				$scope.searchLoading = false;
			} else if (typed.match(addressRegex) !== null) {
				searchType = L.SearchType.ADDRESS;
				if (addressSearchResource.query instanceof Function) {
					addressSearchResource.query({ address: typed }, null, function(result: IResourceAddressFinder<IAddressSearchResource>) {
						let places: string[] = [];
						let max = 10;
						let i = 0;
						for (let resource of result.completions) {
							if (i === max - 1) {
								let trustedHtml = (SearchCtrl.MORE_RESULTS);
								places.push(trustedHtml);
								break;
							}
							places.push(resource.a);
							i++;
						}
						addresses = result.completions;
						$scope.places = places;
						logSearch("ADDRESS_SEARCH", typed);
						checkForNoResults();
					}).$promise.finally(() => {
                        $scope.searchLoading = false;
                    })
				}
			} else if (typed.match(placeRegex) !== null) {
				searchType = L.SearchType.PLACE;
				if (placeNameSearchResource.query instanceof Function) {
					this.placeNameRequest && this.placeNameRequest.$cancelRequest && this.placeNameRequest.$cancelRequest();
					this.placeNameRequest = placeNameSearchResource.query({
						name: typed
					}, null, function(resp: any) {
						logSearch("PLACE_SEARCH", typed);
						let result = <ng.resource.IResourceArray<IPlaceNameSearchResource>> resp.response;
						$scope.places = [];
						let myPlaces: string[] = [];
						let max = 10;
						let i = 0;
						for (let resource of result) {
							if (i === max - 1) {
								myPlaces.push(SearchCtrl.MORE_RESULTS);
								break;
							}
							let newName = PlaceNameSearchService.getLongName(resource);
							if (myPlaces.indexOf(newName) === -1) {
								myPlaces.push(newName);
								i++;
							}
						}
						places = result;
						$scope.places = myPlaces;
						console.log('in order myPlaces:', myPlaces);
						checkForNoResults();
					})
                    .$promise.finally(() => {
                        $scope.searchLoading = false;
                    })
				}
			}
		};
	}
}
